import moment from "moment";

export const isIOS = () => {
    return (
        navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
        navigator.userAgent.match(/AppleWebKit/)
    );
};

export function getCurrentPrayer(times) {
    // Текущее время в указанном часовом поясе
    const now = moment()
    const currentMinutes = now.hours() * 60 + now.minutes();

    // Конвертируем времена намазов в минуты
    const prayerTimes = Object.entries(times).map(([prayer, time]) => {
        const [hours, minutes] = time.split(':').map(Number);
        return { prayer, timeInMinutes: hours * 60 + minutes };
    });

    for (let i = 0; i < prayerTimes.length; i++) {
        const currentPrayer = prayerTimes[i];
        const nextPrayer = prayerTimes[i + 1];

        if (currentMinutes < currentPrayer.timeInMinutes) {
            return prayerTimes[i - 1]?.prayer || currentPrayer.prayer;
        }
        if (
            currentMinutes >= currentPrayer.timeInMinutes &&
            (!nextPrayer || currentMinutes < nextPrayer.timeInMinutes)
        ) {
            return currentPrayer.prayer;
        }
    }
    return 'isha'; // Если время больше последнего намаза
}

export const toCurrencyFormat = (amount, currency) => {
    if (!amount) {
        amount = 0
    }

    if (typeof amount === 'string') {
        amount = Number(amount)
    }

    const format = new Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    return format.format(amount)
}

export const CURRENCY = {
    "USD": 'USD',
    'KZT': 'KZT',
    'RUB': 'RUB'
}